import { css, styled } from 'goober';

import { ArrowSvg } from '../../assets/svg/ArrowSvg';
import { IQuizItem } from '../../types/quiz';
import { splitArray } from '../../utils/array';
import { OptionButton } from '../buttons/OptionButton';

type Props = {
  item: IQuizItem;
  onSubmit: (value: string) => void;
  selected?: Record<string, boolean>;
};

export const OptionButtons = ({ item, onSubmit, selected }: Props) => {
  const options = item?.options;
  const columns = item?.cols ? item.cols : 1;
  const Icon = {
    arrow: ArrowSvg,
    none: null,
  }[item?.optionIcon || 'none'];

  const btnClass = (isSelected?: boolean) => {
    if (isSelected) {
      const activeStyle = css({
        borderColor: '#e9af50',
        backgroundColor: '#fff1d9',
      });
      return `${activeStyle} q-option-button`;
    }
    return 'q-option-button';
  };

  const onClick = (v: string) => (e: any) => {
    if (e.target) {
      if (selected?.[v]) {
        e.target.classList.remove('active');
      } else {
        e.target.classList.add('active');
      }
    }
    onSubmit(v);
  };

  const renderButton = (o: string) => (
    <OptionButton
      key={o}
      onClick={onClick(o)}
      className={btnClass(selected?.[o])}>
      {o}
      {Icon && <Icon />}
    </OptionButton>
  );

  if (!options) {
    return null;
  }

  if (columns === 1) {
    return <Col id="option-buttons">{options.map(renderButton)}</Col>;
  }
  const [col1, col2] = splitArray(options);
  return (
    <Cols id="option-buttons">
      <Col>{col1.map(renderButton)}</Col>
      <Col>{col2.map(renderButton)}</Col>
    </Cols>
  );
};

const Cols = styled('div')`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: 568px) {
    flex-direction: row;
  }
`;

const Col = styled('div')`
  flex: 1;
  width: 100%;
  display: flex;
  margin: 0px 0.25rem;
  align-items: center;
  flex-direction: column;
`;
